import User from "../../../models/user.model";
import * as AuthActions from "./auth.actions";
import { SignupSuccessPayloadType } from "./auth.action.types";

export type TfaType = {
  msg: string | null;
  token: string | null;
  email: string | null;
  qrcode: string | null;
  method: string | null;
  loading: boolean;
};

export interface State {
  user: User | null;
  authError: string | null;
  token: string | null;
  loading: boolean;
  msg: string | null;
  tfa: TfaType;
}

const initialState: State = {
  user: null,
  authError: null,
  token: null,
  loading: false,
  msg: null,
  tfa: {
    msg: null,
    token: null,
    email: null,
    qrcode: null,
    method: null,
    loading: false,
  },
};

export function authReducer(state = initialState, action: any) {
  switch (action.type) {
    case AuthActions.RESET_ERROR: {
      return {
        ...state,
        authError: null,
        loading: false,
      }
    }
    case AuthActions.SIGNUP_START:
      return {
        ...state,
        token: null,
        user: null,
        authError: null,
        loading: true,
      };
    case AuthActions.SIGNUP_SUCCESS:
      const _payload = action.payload as SignupSuccessPayloadType;
      return {
        ...state,
        user: null,
        token: _payload.token,
        authError: null,
        loading: false,
      };
    case AuthActions.VERIFY_EMAIL:
      return {
        ...state,
        authError: null,
        loading: true,
      };
    case AuthActions.RESEND_VERIFY_EMAIL:
      return {
        ...state,
        loading: true,
        authError: null,
      };
    case AuthActions.RESEND_SUCCESS:
      return {
        ...state,
        loading: false,
        token: action.payload,
      };
    case AuthActions.AUTHENTICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        authError: null,
        user: action.payload.user,
        msg: action.payload.msg,
        token: action.payload.token || state.token,
        tfa: {
          ...state.tfa,
          loading: false,
        },
      };
    case AuthActions.AUTHENTICATION_FAILED:
      return {
        ...state,
        loading: false,
        user: null,
        authError: action.payload,
      };
    case AuthActions.SIGNIN_START:
      return {
        ...state,
        loading: true,
        authError: null,
      };
    case AuthActions.CHANGE_WALLET:
      return {
        ...state,
        loading: true,
        authError: null,
      };
    case AuthActions.AUTH_UPDATE_FAILED:
      return {
        ...state,
        loading: false,
        authError: action.payload,
      };
    case AuthActions.AUTH_UPDATE_SUCCESS:
      return {
        ...state,
        user: { ...state.user, ...action.payload.user },
        loading: false,
        msg: action.payload,
      };
    case AuthActions.CHANGE_2FA:
      return {
        ...state,
        loading: true,
        authError: null,
        msg: null,
        tfa: {
          loading: true,
          msg: null,
          token: null,
          email: null,
          qrcode: null,
        },
      };
    case AuthActions.CHANGE_2FA_SUCCESS:
      return {
        ...state,
        loading: false,
        authError: null,
        tfa: action.payload,
      };
    case AuthActions.BEFORE_TFA_LOGIN:
      return {
        ...state,
        loading: false,
        authError: null,
        tfa: action.payload,
      };
    case AuthActions.TFA_FOR_LOGIN:
      return {
        ...state,
        loading: true,
        authError: null,
      };
    case AuthActions.TFA_FOR_LOGIN_FAILED:
      return {
        ...state,
        loading: false,
        authError: action.payload,
      };
    case AuthActions.AUTO_LOGIN:
      return {
        ...state,
        loading: true,
        authError: null,
      };
    case AuthActions.CONFIRM_2FA:
      return {
        ...state,
        tfa: {
          ...state.tfa,
          loading: true,
        },
      };
    case AuthActions.LOGOUT_SUCCESS:
      localStorage.removeItem("accessToken");
      return {
        ...state,
        user: null,
        authError: null,
        token: null,
        loading: false,
        msg: null,
        tfa: {
          msg: null,
          token: null,
          email: null,
          qrcode: null,
          method: null,
          loading: false,
        },
      };
    case AuthActions.RESET_PASSWORD:
      return {
        ...state,
        authError: null,
        loading: true,
        msg: null,
        token: null,
      };
    case AuthActions.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        msg: action.payload.msg,
        token: action.payload.token,
      };
    case AuthActions.CHANGE_ROLE:
      return {
        ...state,
        loading: true,
        authError: null,
        msg: null,
      };
    case AuthActions.CHANGE_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        authError: null,
        user: action.payload.user,
        msg: action.payload.msg,
      };
    case AuthActions.CHANGE_ROLE_FAILED:
      return {
        ...state,
        loading: false,
        authError: action.payload,
      };
    case AuthActions.UPDATE_EXTERNAL_SOURCES_SUCCESS:
      return {
        ...state,
        loading: false,
        authError: null,
        user: action.payload.user,
        msg: action.payload.msg,
      };
    case AuthActions.UPDATE_EXTERNAL_SOURCES_FAILED:
      return {
        ...state,
        loading: false,
        authError: action.payload,
        msg: null,
      };
    default:
      return {
        ...state,
      };
  }
}
